var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"wc-row"},[_c('div',{staticClass:"wc-col"},[_c('cp-motor-cockpit',{attrs:{"change-type":_vm.changeType,"partner-proxy-id":_vm.partnerProxyId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }